var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyInfo = function SvgCompanyInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.1673H13V15.5007H18V17.1673Z",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5007H18V18.834H13V20.5007Z",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.834H13V12.1673L18 12.1673V13.834Z",
    fill: "#494949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66667 8.83398H21.3333V13.0007H26.3333V24.6673H28V26.334H8V24.6673H9.66667V8.83398ZM11.3333 24.6673H16.3333V22.1673H18V24.6673H19.6667V10.5007H11.3333V24.6673ZM21.3333 24.6673H24.6667V14.6673H21.3333V16.334H23V18.0007H21.3333V19.6673H23V21.334H21.3333V24.6673Z",
    fill: "#494949"
  })));
};
export { SvgCompanyInfo as ReactComponent };
export default __webpack_public_path__ + "assets/0504c7f6.svg";